import BuildXMLHealth from "../doc/XMLHealth/BuildXMLHealth";
import BuildXMLComertial from "../doc/XMLComertial/BuildXMLComertial";

class FacturaTechHTTP {
  checkStatus(response) {
    switch (response.status) {
      case 500:
        throw new Error(`${response.status} - Server Error!`);
      case 403:
        throw new Error(`${response.status} - Unhautorized!`);
      default:
        break;
    }
  }

  async generateXMLInvoice(
    invoiceData,
    type,
    id_factura_t,
    typeDocumentInvoice,
    viewOnly = false
  ) {
    console.log(
      "invoiceData",
      invoiceData,
      "type",
      type,
      "id_factura_t",
      id_factura_t,
      "typeDocumentInvoice",
      typeDocumentInvoice
    );
    return new Promise((resolve, reject) => {
      if (type == "SALUD") {
        //Factura Electronica en Salud

        if (
          typeDocumentInvoice == null ||
          typeDocumentInvoice == undefined ||
          typeDocumentInvoice == ""
        ) {
          reject(false);
        }

        let num_fac_ter = invoiceData.facturaNumero.num_fac_ter;
        const xml = BuildXMLHealth(invoiceData, typeDocumentInvoice);
        console.log("construye xml",xml);

        let serializeXML = new XMLSerializer().serializeToString(xml);
        const xmlBase64 = window.btoa(
          unescape(encodeURIComponent(serializeXML))
        );
		
        console.log("serializeXML", serializeXML);
        
        if (viewOnly) {
         /*  console.log("XML", xml);
          console.log("serializeXML", serializeXML);
          console.log("id_factura_t", id_factura_t); */
          resolve(true);
        }

        if (typeDocumentInvoice == "INVOICE") {
          //FACTURA
          //console.log("FACTURA-SALUD-INVOICE");
          console.log("se creo nota credito");

          this.sendElectronicInvoiceFTech(xmlBase64, id_factura_t).then(res => {
                        this.getCUFEInvoiceFTech(num_fac_ter, id_factura_t).then((dataResponse) => {
                            console.log(dataResponse);
                            resolve(true);
                        }).catch((error) => {
                            console.log(error);
                            resolve(false);
                        })
                    }).catch(err => {
                        console.log(err);
                        resolve(false);
                    });
        } else {
          //NOTA CREDITO
          console.log("error nota credito");
          this.sendElectronicInvoiceFTech(xmlBase64, id_factura_t).then(res => {
                        this.saveNotaCredito(id_factura_t, invoiceData.detallesReferenciaFactura.num_nota_credito).then((dataResponse) => {
                            console.log(dataResponse);
                            resolve(true);
                        }).catch((error) => {
                            console.log(error);
                            resolve(false);
                        })
                        console.log(res);
                        resolve(true);
                    }).catch(err => {
                        console.log(err);
                        resolve(false);
                    });
        }
      } else {
        //Factura Electronica Comercial

        if (
          typeDocumentInvoice == null ||
          typeDocumentInvoice == undefined ||
          typeDocumentInvoice == ""
        ) {
          reject(false);
        }

        const xml = BuildXMLComertial(invoiceData, typeDocumentInvoice);
        console.log(xml);

        let serializeXML = new XMLSerializer().serializeToString(xml);
        console.log(unescape(encodeURIComponent(serializeXML)));

        const xmlBase64 = window.btoa(
          unescape(encodeURIComponent(serializeXML))
        );

        if (typeDocumentInvoice == "INVOICE") {
          //FACTURA
          console.log("FACTURA-comercial-INVOICE");
          this.sendElectronicInvoiceFTech(xmlBase64, id_factura_t).then(res => {
                        this.getCUFEInvoiceFTech(invoiceData.num_fac_ter, id_factura_t).then((dataResponse) => {
                            console.log(dataResponse);
                            resolve(true);
                        }).catch((error) => {
                            console.log(error);
                            resolve(false);
                        })
                    }).catch(err => {
                        resolve(false);
                    });
        } else {
          //NOTA CREDITO
          console.log("NOTA CREDITO factura comercial");
          this.sendElectronicInvoiceFTech(xmlBase64, id_factura_t).then(res => {
                        this.saveNotaCredito(id_factura_t, invoiceData.detallesReferenciaFactura.num_nota_credito).then((dataResponse) => {
                            console.log(dataResponse);
                            resolve(true);
                        }).catch((error) => {
                            console.log(error);
                            resolve(false);
                        })
                        console.log(res);
                        resolve(true);
                    }).catch(err => {
                        console.log(err);
                        resolve(false);
                    });
        }
      }
    });
  }

  //Importe de Factura a Factura Tech
  async sendElectronicInvoiceFTech(xmlBase64, id_factura_t) {
    return new Promise((resolve, reject) => {
      let dataSend = { base64: xmlBase64, id_factura_t: id_factura_t };
      fetch(process.env.REACT_APP_PUBLIC_URL + "factura-electronica/xml64", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.transactionID != null && res.transactionID != undefined) {
            //Firma el Documento
            this.documentStatusInvoiceFTech(res.transactionID, id_factura_t)
              .then((response) => {
                resolve(response);
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            throw new Error("Transacción No Exitosa");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  //Firmado y Verificacion de la Factura en la Transaccion
  async documentStatusInvoiceFTech(transactionID, id_factura_t) {
    return new Promise((resolve, reject) => {
      let dataSend = {
        transaccionID: transactionID,
        id_factura_t: id_factura_t,
      };
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "factura-electronica/document-status-file",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(dataSend),
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Ocurrio un error con la Facturación Electronica");
          }
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getCUFEInvoiceFTech = (num_fac_ter, id_factura_t) => {
    return new Promise((resolve, reject) => {
      let dataSend = {
        prefijo: num_fac_ter.split("-")[0],
        folio: num_fac_ter.split("-")[1],
      };
      fetch(
        process.env.REACT_APP_PUBLIC_URL + "factura-electronica/get-cufe-file",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(dataSend),
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error(
              "Ocurrio un error con la Facturación Electronica obteniendo el CUFE"
            );
          }
        })
        .then((res) => {
          let cufe = res.return.resourceData.$value;
          this.saveCufe(id_factura_t, cufe)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  saveCufe = (id, cufe) => {
    return new Promise((resolve, reject) => {
      let dataSend = { id_factura_t: id, cufe: cufe };
      fetch(process.env.REACT_APP_PUBLIC_URL + "facturas/save-cufe", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      })
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            resolve(response);
          } else {
            throw new Error("Ocurrio un error con la Facturación Electronica");
          }
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  };

  getCufeConfirmado = (id_factura_t) => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          `facturas/consultar-cufe-confirmado?id_factura_t=${id_factura_t}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Ocurrio un error con la Facturación Electronica");
          }
        })
        .then((data) => {
          resolve(data.factura.cufe);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  };

  async saveNotaCredito(id_factura_t, nota_credito) {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          `factura-electronica/guardar-nota-credito`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify({
            id_factura_t: id_factura_t,
            nota_credito: nota_credito,
          }),
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Ocurrio un error con la Facturación Electronica");
          }
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}

export default new FacturaTechHTTP();
